// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"40":"928cbd28","826":"7b991aba","1105":"0b08488c","2111":"a88472b9","4840":"4137b440","5644":"f3caaee4","8282":"928cbd28","8973":"4e625e61"}[chunkId] + ".chunk.css";
};